// extracted by mini-css-extract-plugin
export default {"bodyText":"styles_bodyText__M3nlJ"};